export type TIncontermCode =
  | 'FOT' // Franco
  | 'FRA' // Cost and freight
  | 'CFR' // Costs, insurance & freight
  | 'CIF' // Costs, insurance & freight
  | 'CPT' // Carriage and insurance paid to
  | 'CIP' // Carriage paid to
  | 'DAT' // Delivered at terminal
  | 'DAP' // Delivered at place
  | 'DDP' // Delivered duty paid
  | 'DAF' // Delivered at frontier
  | 'DDU' // Delivered duty unpaid
  | 'DES' // Delivered ex ship
  | 'DEQ' // Delivered ex quay

/**
 * Menentukan apakah rute harus ditampilkan atau tidak berdasarkan code incoterm yang diterima.
 * @note TIncontermCode adalah daftar incoterm yang memerlukan rute
 * @param incotermCode kode incoterm
 */
export const disableRouteByIncoterm = (incotermCode: TIncontermCode): boolean => {
  switch (incotermCode) {
    case 'FOT':
    case 'FRA':
    case 'CFR':
    case 'CIF':
    case 'CPT':
    case 'CIP':
    case 'DAT':
    case 'DAP':
    case 'DDP':
    case 'DAF':
    case 'DDU':
    case 'DES':
    case 'DEQ':
      return false
    default:
      return true
  }
}
